import { SEARCHBOX_ICON_ID } from "owa-search-constants";
import type { SearchScenarioId } from "owa-search-store";
import { getScenarioIdKey } from "owa-search-store";

/**
 * Converts given scenarioId to a string (to be used as the id for the search box icon).
 * @param scenarioId ID representing search scenario
 */
export default function getSearchIconIdByScenarioId(scenarioId: SearchScenarioId): string {
    return `${SEARCHBOX_ICON_ID}-${getScenarioIdKey(scenarioId)}`;
}
